// Module
var code = `{{#.boolNumericData}}
<reactTooltipDecorator content="{{tooltip}}">
    <reactFormLabel label="{{~/labelText}}">
        <reactCheckbox 
            checked="{{.Checked}}" 
            on-onChange="@this.onBoolDataChanged(\$1)"/>
    </reactFormLabel>
</reactTooltipDecorator>
<terceraNumeric additionalClass="js-bool-numeric-additionalClass" 
                enabled="{{.Checked}}" 
                value="{{.Value}}" 
                minValue="{{minValue}}"
                maxValue="{{maxValue}}"
                step="{{step}}"
                decimalPrecision="{{decimalPrecision}}"/>
{{/}}`;
// Exports
export default code;